export default {
    path: '/driver_ed',
    meta: {
        title: '驾校招生',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/driver_ed`),
}


// WEBPACK FOOTER //
// ./src/views/DriverEd/router.js